import { BrowserModule } from '@angular/platform-browser'
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { HttpModule } from '@angular/http'
import { RoutingModule } from './modules/routing.module'
import { PreguntaService } from './servicios/preguntas.service'
import { TransformacionService } from './servicios/transformacion.service'
import { AppComponent } from './app.component'
import { DeclaracionComponent } from './declaracion/declaracion.component'
import { DeclaracionService } from './servicios/declaracion.service'
import { PolymerModule } from '@codebakery/origami'
import { ErrorsComponent } from './errors/errors.component'
import {RespuestaService} from './servicios/respuesta.service'


@NgModule({
  declarations: [
    AppComponent,
    DeclaracionComponent,
    ErrorsComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    FormsModule,
    PolymerModule.forRoot(),
    HttpModule,
    RoutingModule
  ],
  exports: [RoutingModule, DeclaracionComponent],
  providers: [DeclaracionService, PreguntaService, TransformacionService, RespuestaService],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts